import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiClock, FiCheckCircle, FiArrowRight } = FiIcons;

const PricingSection = () => {
  const scrollToContact = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Start With a FREE Consultation
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Get immediate access to 30+ years of employment law expertise. 
            We'll assess your situation and show you how to aggressively defend your business.
          </p>
        </motion.div>
        
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-blue-50 to-green-50 p-12 rounded-3xl shadow-xl border border-blue-100"
          >
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-600 rounded-full mb-6">
                <SafeIcon icon={FiPhone} className="text-3xl text-white" />
              </div>
              
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                FREE 15-Minute Consultation
              </h3>
              
              <div className="flex items-center justify-center text-4xl font-bold text-blue-600 mb-6">
                <SafeIcon icon={FiClock} className="mr-3" />
                (323) 990-8118
              </div>
              
              <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto">
                Call now to speak directly with John Fagerholm about your employment law challenges. 
                No cost, no obligation – just expert advice from California's most aggressive employer advocate.
              </p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <SafeIcon icon={FiCheckCircle} className="text-2xl text-green-600 mx-auto mb-3" />
                <h4 className="font-semibold text-gray-900 mb-2">Immediate Assessment</h4>
                <p className="text-gray-600 text-sm">Get instant clarity on your legal situation</p>
              </div>
              
              <div className="text-center">
                <SafeIcon icon={FiCheckCircle} className="text-2xl text-green-600 mx-auto mb-3" />
                <h4 className="font-semibold text-gray-900 mb-2">Strategic Guidance</h4>
                <p className="text-gray-600 text-sm">Learn how to protect your business interests</p>
              </div>
              
              <div className="text-center">
                <SafeIcon icon={FiCheckCircle} className="text-2xl text-green-600 mx-auto mb-3" />
                <h4 className="font-semibold text-gray-900 mb-2">No Obligations</h4>
                <p className="text-gray-600 text-sm">Free advice with no strings attached</p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href="tel:323-990-8118"
                className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-colors flex items-center justify-center group"
              >
                Call Now: (323) 990-8118
                <SafeIcon icon={FiPhone} className="ml-2 group-hover:scale-110 transition-transform" />
              </motion.a>
              
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToContact}
                className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 transition-colors flex items-center justify-center group"
              >
                Schedule a Consultation
                <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </motion.button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;